import { useCallback, useEffect, useRef, useState } from 'react';
import { TBD_GRADE } from '../constants/grades';
import { getStudentRowId } from '../utils/customEvents';
import { useWeeklyEventsSubscriber } from './useWeeklyReportEvents';
import { calculateScrollTop } from '../utils/styles';
import { useWeeklyDashboardContext } from '../context';
var useStudentRow = function (student) {
    var notSeenStruggleNumber = student.notSeenStruggleNumber;
    var _a = useWeeklyDashboardContext(), _b = _a.calendarData, days = _b.days, isCurrentWeek = _b.isCurrentWeek, isWeekInThePast = _b.isWeekInThePast, _c = _a.modals, toggleAccuracyModal = _c.toggleAccuracyModal, isAccuracyModalOpen = _c.isAccuracyModalOpen, isInfoModalOpen = _c.isInfoModalOpen;
    var _d = useState(false), isActivityStream = _d[0], setIsActivityStream = _d[1];
    var _e = useState(0), clickCount = _e[0], setClickCount = _e[1];
    var _f = useState(notSeenStruggleNumber === 0), isCardsWasSeen = _f[0], setIsCardsWasSeen = _f[1];
    var rowRef = useRef(null);
    var _g = useWeeklyEventsSubscriber(), subscribe = _g.subscribe, unsubscribe = _g.unsubscribe;
    var hasTouchedCards = student.activityCalendar.filter(function (ac) { return ac.cardsTouched > 0; }).length > 0;
    var hasAssignments = student.activityCalendar
        .map(function (ac) { return ac.assignments; })
        .some(function (a) { return a.length > 0; });
    var isActive = hasTouchedCards || hasAssignments;
    useEffect(function () {
        if (clickCount === 2) {
            setIsCardsWasSeen(true);
        }
    }, [clickCount]);
    var activateRow = useCallback(function (rowId) {
        if (rowId.includes(getStudentRowId(student.id))) {
            setIsActivityStream(true);
            setClickCount(function (prev) { return prev + 1; });
            if (rowRef.current) {
                setTimeout(function () {
                    window.scrollTo({
                        top: calculateScrollTop(rowRef.current, {
                            includeHeaderOffset: true,
                            withFilter: false,
                            isWeekInThePast: isWeekInThePast,
                        }),
                        behavior: 'smooth',
                    });
                }, 500);
            }
        }
    }, [isWeekInThePast, student.id]);
    var handleActivateRowEvent = useCallback(function (evt) {
        var rowId = evt.detail.rowId;
        activateRow(rowId);
    }, [activateRow]);
    useEffect(function () {
        subscribe('activate-row', handleActivateRowEvent);
        return function () {
            unsubscribe('activate-row', handleActivateRowEvent);
        };
    }, [handleActivateRowEvent, subscribe, unsubscribe]);
    return {
        rowRef: rowRef,
        isActivityStream: isActivityStream,
        setIsActivityStream: setIsActivityStream,
        clickCount: clickCount,
        setClickCount: setClickCount,
        isCardsWasSeen: isCardsWasSeen,
        isActive: isActive,
        isTbd: student.grade === TBD_GRADE,
        isCurrentWeek: isCurrentWeek,
        isAccuracyModalOpen: isAccuracyModalOpen,
        isInfoModalOpen: isInfoModalOpen,
        toggleAccuracyModal: toggleAccuracyModal,
        isWeekInThePast: isWeekInThePast,
        days: days,
    };
};
export { useStudentRow };
